import { getSessionSafe } from './supabase'
import useLocationReminderStore from '../store/locationReminderStore'

/**
 * Trigger immediate traffic check via refresh-travel-time edge function.
 */
export async function triggerTrafficCheck(taskId) {
  try {
    const session = await getSessionSafe()
    if (!session?.access_token) {
      console.warn('[checkTrafficReminder] No session for traffic check')
      return
    }

    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
    const response = await fetch(`${supabaseUrl}/functions/v1/refresh-travel-time`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`,
      },
      body: JSON.stringify({ taskId }),
    })

    if (response.ok) {
      const result = await response.json()
      console.log('[checkTrafficReminder] Traffic check triggered:', result)
    } else {
      console.warn('[checkTrafficReminder] Traffic check failed:', response.status)
    }
  } catch (err) {
    console.error('[checkTrafficReminder] Error:', err.message)
  }
}

/**
 * Schedule a reload of location reminders after a delay AND trigger traffic check.
 */
export async function scheduleTrafficRefresh(taskId, delay = 1000) {
  if (!taskId) return

  // Trigger traffic check immediately with taskId
  await triggerTrafficCheck(taskId)

  // Then reload the reminder after a delay
  setTimeout(() => {
    try {
      console.log('[checkTrafficReminder] Refreshing location reminder from store')
      const loadForTask = useLocationReminderStore.getState().loadForTask
      loadForTask(taskId).catch(err => console.warn('[checkTrafficReminder] Refresh failed:', err.message))
    } catch (err) {
      console.warn('[checkTrafficReminder] Schedule error:', err.message)
    }
  }, delay)
}
